import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BaseService } from '@tcc-mono/shared/data-access';
import { APP_CONFIG, IAppConfig } from '@tcc-mono/shared/app-config';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class GameAudioService extends BaseService<any> {

  constructor(
    _http: HttpClient,
    @Inject(APP_CONFIG) appConfig: IAppConfig
  ) {
    super(_http, appConfig);
    this.path = '/api/game/'
  }

  getAudioStream(): Observable<Blob> {
    return this._http.get(`${this.getUrl(`${this.path}/play-music`)}`, { responseType: 'blob' });
  }

}
